module.exports = __webpack_public_path__ + "static/media/mineraçao-img2.c2f8d044.jpg";